<template>
  <q-list>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_1" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I certify I am over 18 years of age and legally authorized to change the Retail Electric Provider for the
          address listed under Service Information. I agree that I have decided to change service from my current REP to
          Atlantex Power. I affirm that I designated Atlantex Power to perform the tasks necessary to complete a switch
          for me at this address.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_2" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I have read and accept the
          <a :href="plan_doc_link(selected_plan, 'tos')" target="_blank" class="cp-non-link">Terms of Service</a>,
          <a :href="plan_doc_link(selected_plan, 'efl')" target="_blank" class="cp-non-link">EFL</a>,
          and <a :href="plan_doc_link(selected_plan, 'yrac')" target="_blank" class="cp-non-link">YRAC</a>,
          and I agree to receive all contract documents and other written communications electronically from Atlantex
          Power.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_3" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I understand and agree that I will receive SMS text messages and/or an email to the contact information
          provided above solely for the purpose of verifying my identity and facilitating my electric service.
        </q-item-label>
      </q-item-section>
    </q-item>

  </q-list>
</template>

<script>
import SelectedPlan from "src/composables/SelectedPlan";
import Utilities from "src/composables/Utilities";
import { computed, ref, watch } from "vue";
export default {
  name: "AtlantexAuthorizations",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { selected_plan } = SelectedPlan();
    const { plan_brand, plan_doc_link } = Utilities();
    const authorizations = ref([]);
    watch(authorizations, () => {
      const agreed = authorizations.value.length === 3
      emit('update:modelValue', agreed);
    })
    return {
      authorizations,
      selected_plan,
      plan_brand,
      plan_doc_link
    }
  }
}
</script>

<style scoped>
</style>
